import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormFields } from "../components/form-fields/form-fields.component";
import { JsonSchemaInfoBasePropertiesFormProperties } from "../models/campaign-3.model";
import { Campaign3TestService } from "../services/campaign3testservice";
import { Campaign3 } from "app/models/campaign3.model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";


@Component({
  selector: 'app-new-campaign-3',
  templateUrl: './new-campaign-3.component.html',
  styleUrls: ['./new-campaign-3.component.css']
})
export class NewCampaign3Component implements OnInit {

  newFieldModel = {
    campaign_name: null,
    campaign_description: null,
    start_date: null,
    end_date: null,
    budget_type: null,
    budget_value: null,
    campaign_type: null,
  };
  errors = {
    campaign_name: false,
    start_date: false,
    end_date: false,
    campaign_type: false,
    campaign_description: false,
    budget_type: false,
    budget_value: false
  };


  @Input() budgetTypeList: Array<{ label: string, value: number }> = [];
  @Input() campaignTypeList: Array<{ label: string, value: number }> = [];
  @Input() statusList: Array<{ label: string, value: number }> = [];
  @Input() formSchema: JsonSchemaInfoBasePropertiesFormProperties;

  @Output() refreshPage = new EventEmitter();
  @Output() closeCreationPopup = new EventEmitter<any>();

  @ViewChild('campaign_name') campaign_name: FormFields;
  @ViewChild('campaign_description') campaign_description: FormFields;
  @ViewChild('start_date') start_date: FormFields;
  @ViewChild('end_date') end_date: FormFields;
  @ViewChild('budget_type') budget_type: FormFields;
  @ViewChild('budget_value') budget_value: FormFields;
  @ViewChild('status') status: FormFields;
  @ViewChild('campaign_type') campaign_type: FormFields;

  constructor(
    public testService: Campaign3TestService,
    public srvCalendar: CalendarTranslateService) {
  }

  ngOnInit() {
    //rimuovo il record vuoto presente nella lista passata dai filtri della kontable
    this.campaignTypeList = this.campaignTypeList.filter(item => item.label.trim() !== '');

    // Imposto il primo record della lista come valore predefinito per campaign_type
    if (this.campaignTypeList.length === 1) {
      this.newFieldModel.campaign_type = this.campaignTypeList[0];

    }
    this.statusList = this.statusList.filter(item => item.label.trim() !== '');
    this.budgetTypeList = this.budgetTypeList.filter(item => item.label.trim() !== '');

  }

  validateFields() {
    // Controllo per ciascun campo
    for (const field in this.newFieldModel) {
      if (!this.newFieldModel[field]) {
        this.errors[field] = true;
      } else {
        this.errors[field] = false;
      }
    }
    // Controllo della relazione tra start_date e end_date
    if (this.newFieldModel.start_date && this.newFieldModel.end_date) {
      const startDate = new Date(this.newFieldModel.start_date);
      const endDate = new Date(this.newFieldModel.end_date);

      // Crea una data di oggi senza tempo (ore, minuti, secondi)
      const today = new Date();
      today.setHours(0, 0, 0, 0);  // Rimuove l'orario

      // Reset degli errori
      this.errors.start_date = false;
      this.errors.end_date = false;

      // Controllo se la start_date è successiva o uguale a end_date
      if (startDate >= endDate) {
        this.errors.start_date = true;
        this.errors.end_date = true;
        this.start_date.valid = false;
        this.start_date.errorMessage = "Incongruenza tra data di inizio e di fine"
        this.end_date.valid = false;
        this.end_date.errorMessage = "Incongruenza tra data di inizio e di fine"
      }

      // Controllo se end_date è nel passato
      if (endDate < today) {
        this.errors.end_date = true;

        this.end_date.valid = false;
        this.end_date.errorMessage = "Attenzione! Data di fine è nel passato"
      }
    }
    if (this.newFieldModel.start_date && this.newFieldModel.end_date) {
      const startDate = new Date(this.newFieldModel.start_date);
      const endDate = new Date(this.newFieldModel.end_date);
      if (startDate >= endDate) {
        this.errors.start_date = true;
        this.errors.end_date = true;
      }
    }
  }

  OnSaveEntity() {


    this.campaign_name.performValidation();
    this.campaign_description.performValidation();
    this.budget_type.performValidation();
    this.budget_value.performValidation();
    this.campaign_type.performValidation();
    this.start_date.performValidation();
    this.end_date.performValidation();
 
    this.validateFields();

   

    // Verifico se oggetto error ha dei parametri settati a true
    const errorValues = Object.keys(this.errors).map(key => this.errors[key]);
    const hasErrors = errorValues.some(error => error);
    console.log(hasErrors)

    // Se ci sono errori, non salvare l'entità e aprire popup
    if (hasErrors) {
      console.log("abort saving, there are some errors", this.newFieldModel);
      for (const key in this.errors) {
        if (Object.prototype.hasOwnProperty.call(this.errors, key)) {
          this.errors[key] = false;
        }
      }
      return;
    }
    this.newFieldModel.start_date = this.dateConverter(this.newFieldModel.start_date);
    this.newFieldModel.end_date = this.dateConverter(this.newFieldModel.end_date);

    let newCampaign = new Campaign3();

    newCampaign.name = this.newFieldModel.campaign_name;
    newCampaign.start_date = this.newFieldModel.start_date;
    newCampaign.end_date = this.newFieldModel.end_date;
    newCampaign.campaign_type_id = this.newFieldModel.campaign_type.value;
    newCampaign.description = this.newFieldModel.campaign_description;
    newCampaign.budget_type_id = this.newFieldModel.budget_type.value;
    newCampaign.budget = this.newFieldModel.budget_value;
    newCampaign.priority = 0; // Valore di priorità predefinito
    newCampaign.campaign_status_id = this.statusList.find(x => x.label == "IN CREAZIONE").value;


    this.testService.saveNewCampaign(newCampaign).subscribe(res => {
      console.log(res);
      this.closeCreationPopup.emit();
      this.refreshPage.emit();
    });
  }

  onClosePopup() {
    this.closeCreationPopup.emit();
  }

  dateConverter(event) {
    try {
      const data = new Date(event);
      const giorno = data.getDate();
      const mese = data.getMonth() + 1;
      const anno = data.getFullYear();
      const giornoFormattato = giorno < 10 ? '0' + giorno : giorno;
      const meseFormattato = mese < 10 ? '0' + mese : mese;
      return anno + '-' + meseFormattato + '-' + giornoFormattato;
    } catch (error) {
      console.error('Si è verificato un errore durante la conversione della data:', error);
      return null; // Ritorna null in caso di errore
    }
  }


}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/new-campaign-3/new-campaign-3.component.ts